import { useContext } from "react";
import { useSelector } from "react-redux";
import { Gantt } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  gantt: Gantt;
  retrieveZonesProjectsGantt(
    request: Boundaries["retrieveZonesProjectsGantt"]["request"],
  ): void;
}

function useRetrieveZonesProjectsGantt(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveZonesProjectsGanttRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveZonesProjectsGanttRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveZonesProjectsGanttRequestFailure,
    ),
    gantt: useSelector(selector.getZonesProjectsGantt),
    retrieveZonesProjectsGantt: core.retrieveZonesProjectsGantt,
  };
}

export { useRetrieveZonesProjectsGantt };
